import { Auth } from 'services'

const auth = new Auth()

const Unauthenticated = (props: any) => {
    return !auth.isAuthenticated() && props.children
}

export default Unauthenticated



// WEBPACK FOOTER //
// ./src/components/Unauthenticated/index.tsx